<template>
  <el-popover
    placement="bottom"
    width="210"
    trigger="click"
    v-model="showSelector"
  >
    <div class="plan-selector">
      <el-cascader
        ref="cascaderRef"
        v-model="selectedPlan"
        :props="planSelectorConfig"
        size="mini"
        popper-class="plan-selector-popper"
        @expand-change="expand"
      ></el-cascader>
      <el-button type="primary" size="mini" @click="confirmPlan" class="confirm-btn">确定</el-button>
    </div>
    <el-button type="text" slot="reference">{{ btnName }}</el-button>
  </el-popover>
</template>
<script>
import { getCarResourceBrands, getPlans, getCarResourceSeries } from '@/api/carResource/index'

export default {
  name: 'planSelector',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    btnName: {
      type: String,
      default: '选择方案',
    },
    // 方案类型
    leaseType: {
      type: Number,
      default: null,
    },
  },
  data() {
    const instance = this
    return {
      // 展示开关
      showSelector: this.show,
      // 方案选择结果
      selectedPlan: null,
      // 选择的品牌
      selectedBrand: null,
      // 选择的车系
      selectedSeries: null,
      planSelectorConfig: {
        expandTrigger: 'click',
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node
          if (level === 0) {
            // 获取有车源方案的品牌
            instance.getBrands(resolve)
          } else if (level === 1) {
            instance.selectedBrand = node.data.value
            // 获取车系
            instance.getSeries(resolve)
          } else if (level === 2) {
            instance.selectedSeries = node.data.value
            // 获取方案
            instance.getPlans(resolve)
          } else {
            node.loaded = true
            node.loading = false
            resolve()
          }
        },
      },
    }
  },
  methods: {
    // 确认方案
    confirmPlan() {
      this.showSelector = false
      if (this.selectedPlan && this.selectedPlan.length !== 0) {
        this.$emit('confirmPlan', this.selectedPlan[this.selectedPlan.length - 1])
      }
      this.selectedPlan = null
    },
    // 获取车源品牌
    getBrands(resolve) {
      getCarResourceBrands({ leaseType: this.leaseType }).then((res) => {
        if (res.code === 1 && res.data) {
          const brands = res.data.map((item) => {
            return {
              value: item.id,
              label: item.brand,
              leaf: false,
            }
          })
          resolve(brands)
        } else {
          resolve([])
        }
      })
    },
    // 获取车源车系
    getSeries(resolve) {
      getCarResourceSeries({
        brandId: this.selectedBrand,
        leaseType: this.leaseType,
      }).then((res) => {
        if (res.code === 1 && res.data) {
          const series = res.data.map((item) => {
            return {
              value: item.seriesId,
              label: item.series,
              leaf: false,
            }
          })
          resolve(series)
        } else {
          resolve([])
        }
      })
    },
    // 获取车源方案
    getPlans(resolve) {
      getPlans({
        brandId: this.selectedBrand,
        seriesId: this.selectedSeries,
        leaseType: this.leaseType,
      }).then((res) => {
        if (res.code === 1 && res.data) {
          const plans = res.data.map((item) => {
            return {
              value: item.id,
              label: `${item.title} \t ${item.leasePeriods}期  ${item.rent}元/期  ${item.releaseTenantName}  ${item.transactionCityName}`,
              leaf: true,
            }
          })
          resolve(plans)
        } else {
          resolve()
        }
      })
    },
    expand(arr) {
      this.selectedBrand = arr[0]
    },
  },
  mounted() {
    this.$refs.cascaderRef.$refs.popper.onmouseleave = () => {
      this.$refs.cascaderRef.dropDownVisible = false
    }
  },
}
</script>
<style scoped lang="scss">
.plan-selector {
  display: flex;
}
.confirm-btn {
  margin-left: 8px;
}
</style>
